import { Button, Form, Input, Select } from 'antd'
import { Typography } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Tank } from '@/types'
import { CreateMachineRequest } from '@/types/apis/machines/CreateMachineRequest'

import { SpaceCustom } from '../../style'

type Props = {
  loading: boolean
  onSubmit: (formValues: CreateMachineRequest) => void
  tanks: Tank[] | undefined
}

const { Title } = Typography

const CreateMachineForm = ({ loading, onSubmit, tanks }: Props) => {
  const { t } = useTranslation()

  return (
    <Form layout="vertical" onFinish={onSubmit}>
      <Title level={4}>{t('components.pages.machines.create.form.washingInfo')}</Title>
      <Form.Item
        label={t('components.pages.machines.create.form.name')}
        name="name"
        rules={[{ required: true, message: t('components.pages.machines.create.form.requireName') }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label={t('components.pages.machines.create.form.typeName')}
        name="typeName"
        rules={[{ required: true, message: t('components.pages.machines.create.form.requireTypeName') }]}
      >
        <Input />
      </Form.Item>

      <Title level={4}>{t('components.pages.machines.create.form.tankInfo')}</Title>
      <Form.Item label={t('components.pages.machines.create.form.tankNo')} name="tankIds">
        <Select mode="multiple" style={{ border: '1px solid #ccc' }}>
          {tanks?.map((tank) => (
            <Select.Option key={tank.id} value={tank.id}>
              {`${tank.tankNo} ${tank.detergents[0] ? tank.detergents[0].name : ''}`}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>

      <SpaceCustom>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading}>
            {t('components.pages.machines.create.form.submit')}
          </Button>
        </Form.Item>
      </SpaceCustom>
    </Form>
  )
}

CreateMachineForm.displayName = 'CreateMachineForm'
export default CreateMachineForm
